/* Cara Dura · Alza Dura page behaviour:
   top bar above the header + countdown to a fixed end date, height cards -> product variant (and Kaching per-pair selects),
   "pack 3 alturas" presets one pair of each height, delivery dates, notes moved next to the buy button,
   sticky bar following the selected Kaching tier, buttons that scroll to a target, expert card moved under the gallery. */
(function () {
  var MONTHS = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* Top bar: move above the theme header, countdown to a fixed date (Mexico City time). */
  function initTop() {
    var top = q('[data-cda-top]');
    if (!top || top.getAttribute('data-ready')) return;
    top.setAttribute('data-ready', '1');
    var header = q('.shopify-section-group-header-group');
    var wrap = top.closest('.shopify-section') || top;
    if (header && header.parentNode) header.parentNode.insertBefore(wrap, header);
    var cd = q('[data-cda-countdown]', top);
    if (!cd) return;
    var raw = (cd.getAttribute('data-cda-countdown') || '').trim().replace(' ', 'T');
    if (!raw) return;
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw += (raw.length <= 10 ? 'T23:59' : '') + ':00-06:00';
    var end = new Date(raw).getTime();
    if (isNaN(end)) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { cd.hidden = true; return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
      cd.textContent = (d > 0 ? d + ' D : ' : '') + pad(h) + ' H : ' + pad(m) + ' MIN : ' + pad(x) + ' S';
      cd.hidden = false;
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* Variant + Kaching per-pair selects */
  function form() {
    var fs = qa('form[action*="/cart/add"]');
    for (var i = 0; i < fs.length; i++) if (!fs[i].closest('.cdl-sticky')) return fs[i];
    return null;
  }
  function setVariant(id) {
    var f = form();
    if (f) {
      qa('[name="id"]', f).forEach(function (el) { if (el.value !== id) { el.value = id; el.dispatchEvent(new Event('change', { bubbles: true })); } });
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u.toString()); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cda:variant', { detail: { id: id } }));
  }
  function kachingSelects() {
    var kb = q('kaching-bundle');
    if (!kb) return [];
    var bar = q('.kaching-bundles__bar--selected', kb) || kb;
    return qa('select', bar);
  }
  function setPairs(ids) {
    var sels = kachingSelects();
    sels.forEach(function (s, i) {
      var want = String(ids[i % ids.length]);
      var opt = qa('option', s).filter(function (o) { return o.value === want || (o.getAttribute('data-variant-id') === want); })[0];
      if (opt && s.value !== opt.value) { s.value = opt.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  function initHeights() {
    var box = q('[data-cda-heights]');
    if (!box || box.getAttribute('data-ready')) return;
    box.setAttribute('data-ready', '1');
    var cards = qa('[data-cda-variant]', box);
    var pack = q('[data-cda-pack]');
    var mode = 'single', current = null;
    function select(card) {
      cards.forEach(function (c) { c.classList.toggle('is-on', c === card); c.setAttribute('aria-pressed', c === card); });
      if (pack) { pack.classList.remove('is-on'); pack.setAttribute('aria-pressed', 'false'); }
      mode = 'single'; current = card.getAttribute('data-cda-variant');
      setVariant(current); setPairs([current]);
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    if (pack) pack.addEventListener('click', function () {
      cards.forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
      pack.classList.add('is-on'); pack.setAttribute('aria-pressed', 'true');
      mode = 'pack';
      var ids = (pack.getAttribute('data-cda-pack') || '').split(',');
      setVariant(ids[0]); setPairs(ids);
    });
    var pre = q('[data-cda-variant].is-on', box);
    if (pre) current = pre.getAttribute('data-cda-variant');
    /* Kaching re-renders its bars when the tier changes: re-apply the heights. */
    var kb = q('kaching-bundle');
    if (kb && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (mode === 'pack' && pack) setPairs((pack.getAttribute('data-cda-pack') || '').split(','));
          else if (current) setPairs([current]);
        }, 120);
      }).observe(kb, { childList: true, subtree: true });
    }
  }

  /* Notes (pairs + delivery) placed right above the buy button, under the Kaching tiers. */
  function initNotes() {
    var notes = q('[data-cda-notes]');
    if (!notes || notes.getAttribute('data-ready')) return;
    notes.setAttribute('data-ready', '1');
    var btn = q('.shop-add-to-cart-button');
    if (btn && btn.parentNode) btn.parentNode.insertBefore(notes, btn);
    var out = q('[data-cda-ship-dates]', notes);
    if (!out) return;
    var rules = (notes.getAttribute('data-ship') || '').split(',');
    var cc = (window.Shopify && Shopify.country) || '';
    var min = 6, max = 10;
    var hit = {};
    rules.forEach(function (r) {
      var m = r.trim().match(/^([A-Z]{2}|\*):(\d+)-(\d+)$/);
      if (m) hit[m[1]] = [+m[2], +m[3]];
    });
    var use = hit[cc] || hit['*'];
    if (use) { min = use[0]; max = use[1]; }
    function addBiz(n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
      return d;
    }
    var a = addBiz(min), b = addBiz(max);
    out.textContent = a.getMonth() === b.getMonth()
      ? 'el ' + a.getDate() + ' y el ' + b.getDate() + ' de ' + MONTHS[b.getMonth()]
      : 'el ' + a.getDate() + ' de ' + MONTHS[a.getMonth()] + ' y el ' + b.getDate() + ' de ' + MONTHS[b.getMonth()];
  }

  /* Sticky bar follows the selected Kaching tier. */
  function initSticky() {
    var bar = q('[data-cda-sticky]');
    var kb = q('kaching-bundle');
    if (!bar || !kb || bar.getAttribute('data-ready')) return;
    bar.setAttribute('data-ready', '1');
    var l1 = q('[data-cda-sticky-1]', bar), l2 = q('[data-cda-sticky-2]', bar), name = bar.getAttribute('data-name') || '';
    function sync() {
      var sel = q('.kaching-bundles__bar--selected', kb);
      if (!sel) return;
      var t = q('.kaching-bundles__bar-title', sel), s = q('.kaching-bundles__bar-subtitle', sel);
      var m = s && s.textContent.match(/(\d+)\s*pares?/i);
      if (m && l1) l1.textContent = name + ' · ' + m[1] + (m[1] === '1' ? ' par' : ' pares');
      if (t && l2) l2.textContent = t.textContent.trim();
    }
    sync();
    if ('MutationObserver' in window) new MutationObserver(sync).observe(kb, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* Expert card, placed like the reference PDP: desktop under the product gallery (left column),
     mobile at the end of the buy box, after the accordions. Re-placed when crossing the breakpoint. */
  function initExpert() {
    var card = q('.cda-exp-sec .cda-exp') || q('.cda-exp--g') || q('.cda-exp--i');
    var gal = q('.shop-carousel-container'), info = q('.shop-product-info');
    if (!card || !gal || !info) return;
    var sec = q('.cda-exp-sec');
    if (sec) sec.style.display = 'none';
    qa('.cda-exp--g, .cda-exp--i').forEach(function (old) { if (old !== card) old.remove(); });
    function place() {
      var desk = window.innerWidth >= 990;
      card.classList.toggle('cda-exp--g', desk);
      card.classList.toggle('cda-exp--i', !desk);
      var target = desk ? gal : info;
      if (card.parentNode !== target || target.lastElementChild !== card) target.appendChild(card);
      var img = desk && qa('.shop-product-carousel img', gal).filter(function (i) { return i.getBoundingClientRect().width > 200; })[0];
      card.style.width = img ? Math.round(img.getBoundingClientRect().width) + 'px' : '';
    }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    setTimeout(place, 800);
    setTimeout(place, 2500);
  }

  function init() { initTop(); initHeights(); initNotes(); initExpert(); initSticky(); }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target.closest('[role="button"][data-cda-variant], [role="button"][data-cda-pack]');
    if (b) { e.preventDefault(); b.click(); }
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cda-goto]');
    if (!a) return;
    var sel = a.getAttribute('data-cda-goto');
    var t = sel && q(sel);
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { initSticky(); });
  setTimeout(initSticky, 2500);
  document.addEventListener('shopify:section:load', init);
})();
